// /src/hooks/useAdobeAnalytics.js
'use client';

import { useCallback } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Custom hook to provide a function for tracking events with Adobe Analytics.
 */
export function useAdobeAnalytics() {
  const pathname = usePathname();
  const trackEvent = useCallback((region, link) => {
  const pageName = `www:getserious:${pathname === '/' ? 'home' : pathname.replace('/', '')}`;

    console.log(`Tracking Adobe Event: region='${region}', link='${link}'`); // For testing

    // Adobe Analytics
    if (window.s && typeof window.s.tl === 'function') {
      try {
        window.s.linkTrackVars = 'activitymap.region,activitymap.link,prop7,prop8,prop9,link';
        window.s.prop7 = link;
        window.s.prop8 = pageName;
        window.s.prop9 = region;
        window.s.activitymap = { region, link };
        window.s.link = link;
        window.s.tl(true, 'o', `${region}: ${link}`); // Best practice to provide a descriptive link name
      } catch (e) {
        console.error("Adobe Analytics tracking error:", e);
      }
    } else {
        console.warn("Adobe Analytics object (window.s) not found.");
    }

    // Google Analytics (optional, as per your script)
    if (window.gtag) {
        window.gtag('event', 'custom_event', {
            'event_category': region,
            'event_label': link
        });
    }
  }, []);

  return { trackEvent };
}
